import React from 'react';
import { Table, Panel } from 'rsuite';
import NavigationHeader from './NavigationHeader';
import { useTranslation } from 'react-i18next';
const fakeData = [
  {
    id: 1,
    email: 'Leora13@yahoo.com',
    firstName: 'AMZKB1',
    maturity: '6/3/2060',
    price: '$53.4',
    payment: '$0.12',
    walletAddress: 'AASFASFKSFJKSAFASASWAFSFASFASF',
    paymentDate: '6/3/2060',
  },
  {
    id: 2,
    email: 'Leora13@yahoo.com',
    firstName: 'AMZKB1',
    maturity: '6/3/2060',
    price: '$53.4',
    payment: '$0.12',
    walletAddress: 'AASFASFKSFJKSAFASASWAFSFASFASF',
    paymentDate: '6/3/2060',
  },
  {
    id: 3,
    email: 'Leora13@yahoo.com',
    firstName: 'AMZKB1',
    maturity: '6/3/2060',
    price: '$53.4',
    payment: '$0.12',
    walletAddress: 'AASFASFKSFJKSAFASASWAFSFASFASF',
    paymentDate: '6/3/2060',
  },
  {
    id: 4,
    email: 'Leora13@yahoo.com',
    firstName: 'AMZKB1',
    maturity: '6/3/2060',
    price: '$53.4',
    payment: '$0.12',
    walletAddress: 'AASFASFKSFJKSAFASASWAFSFASFASF',
    paymentDate: '6/3/2060',
  },
  {
    id: 5,
    email: 'Leora13@yahoo.com',
    firstName: 'AMZKB1',
    maturity: '6/3/2060',
    price: '$53.4',
    payment: '$0.12',
    walletAddress: 'AASFASFKSFJKSAFASASWAFSFASFASF',
    paymentDate: '6/3/2060',
  },
];

const Payments = () => {
  const { t } = useTranslation();
  const { Column, HeaderCell, Cell, Pagination } = Table;
  return (
    <>
      <NavigationHeader />
      <Panel>
        <h3> {t('payments.payments')}</h3>
        <p>{t('payments.instruction')}</p>
        <br />
        <Table
          height={400}
          data={fakeData}
          onRowClick={(data) => {
            console.log(data);
          }}
        >
          <Column width={70} align="center" fixed>
            <HeaderCell>{t('payments.table.col.id')}</HeaderCell>
            <Cell dataKey="id" />
          </Column>
          <Column width={200} fixed>
            <HeaderCell>Kubond Name</HeaderCell>
            <Cell dataKey="firstName" />
          </Column>
          <Column width={200}>
            <HeaderCell>{t('payments.table.col.1')}</HeaderCell>
            <Cell dataKey="maturity" />
          </Column>
          <Column width={200}>
            <HeaderCell>{t('payments.table.col.2')}</HeaderCell>
            <Cell dataKey="price" />
          </Column>
          <Column width={300}>
            <HeaderCell>{t('payments.table.col.3')}</HeaderCell>
            <Cell dataKey="payment" />
          </Column>
          <Column width={300}>
            <HeaderCell>{t('payments.table.col.4')}</HeaderCell>
            <Cell dataKey="paymentDate" />
          </Column>
          <Column width={300}>
            <HeaderCell>{t('payments.table.col.5')}</HeaderCell>
            <Cell dataKey="walletAddress" />
          </Column>
          <Column width={120} fixed="right">
            <HeaderCell>{t('payments.table.col.6')}</HeaderCell>

            <Cell>
              {(rowData) => {
                function handleAction() {
                  alert(`id:${rowData.id}`);
                }
                return (
                  <span>
                    <a onClick={handleAction}>
                      {' '}
                      {t('payments.table.col.6.1')}{' '}
                    </a>{' '}
                    |{' '}
                    <a onClick={handleAction}>
                      {' '}
                      {t('payments.table.col.6.2')}{' '}
                    </a>
                  </span>
                );
              }}
            </Cell>
          </Column>
        </Table>
      </Panel>
    </>
  );
};

export default Payments;
